{
  "it": {
    "toast": {
      "action": {
        "email_address_taken": "Questo indirizzo email appartiene già a un altro contatto.",
        "failed": "Azione non riuscita",
        "impersonate_unauthorized": "Questa azione non è consentita durante l'impersonificazione di un cliente.",
        "storage_quota_exceeded": "Limite di archiviazione raggiunto. Elimini dei file oppure ci contatti per aggiornare il piano.",
        "succeeded": "Azione riuscita",
        "unprocessable": "Si è verificato un errore, provi ad aggiornare la pagina. Se il problema persiste, ci contatti. \nERRORE: {error}"
      },
      "create": {
        "failed": "Creazione di {itemName} non riuscita",
        "succeeded": "{itemName} creato"
      },
      "delete": {
        "failed": "Eliminazione di {itemName} non riuscita",
        "succeeded": "{itemName} è stato eliminato",
        "succeeded_default": "Eliminazione riuscita"
      },
      "update": {
        "failed": "Aggiornamento di {itemName} non riuscito",
        "succeeded": "{itemName} è stato aggiornato",
        "successfully_saved": "Salvato correttamente"
      },
      "upload": {
        "failed": "Caricamento non riuscito",
        "succeeded": "Caricamento riuscito"
      },
      "upload_document": {
        "extension_invalid": "Il documento \"{document_name}\" non ha un'estensione valida."
      },
      "upload_image": {
        "file_too_big": "File troppo grande: la dimensione massima consentita è 5MB"
      },
      "warning": {
        "multipleFiles": "Questa esportazione contiene più file zip. Il browser potrebbe bloccare i download multipli. Se ha scaricato un solo file zip, contatti il supporto Ziggu."
      }
    }
  }
}
